export default "__VITE_ASSET__DqWQEyr1__"